import { useState, useEffect } from 'react';
import { collection, query, where, getDocs, Timestamp } from 'firebase/firestore';
import { db } from '../firebase/config';

const LAST_VISIT_KEY = 'community_last_visit';

export const useNewPosts = (isViewingCommunity) => {
  const [newPostsCount, setNewPostsCount] = useState(0);

  // Mark community as visited (clears the new posts indicator)
  const markAsVisited = () => {
    localStorage.setItem(LAST_VISIT_KEY, Date.now().toString());
    setNewPostsCount(0);
  };

  // Check for new posts
  useEffect(() => {
    const checkNewPosts = async () => {
      try {
        const lastVisit = localStorage.getItem(LAST_VISIT_KEY);

        // If never visited, don't show indicator (first-time users)
        if (!lastVisit) {
          localStorage.setItem(LAST_VISIT_KEY, Date.now().toString());
          return;
        }

        const lastVisitDate = new Date(parseInt(lastVisit));
        const lastVisitTimestamp = Timestamp.fromDate(lastVisitDate);

        const postsRef = collection(db, 'messageBoard', 'data', 'posts');
        const q = query(
          postsRef,
          where('createdAt', '>', lastVisitTimestamp)
        );

        const snapshot = await getDocs(q);
        setNewPostsCount(snapshot.size);
      } catch (error) {
        // Silently fail - don't break the app if this check fails
        console.warn('Could not check for new posts:', error.message);
      }
    };

    // Only check when not viewing community
    if (!isViewingCommunity) {
      checkNewPosts();
    }
  }, [isViewingCommunity]);

  // Mark as visited when viewing community
  useEffect(() => {
    if (isViewingCommunity) {
      markAsVisited();
    }
  }, [isViewingCommunity]);

  return { newPostsCount, markAsVisited };
};

export default useNewPosts;
